// Function to pad single-digit numbers with leading zero
export function pad(number) {
  return number.toString().padStart(2, '0');
}
